module.exports = __webpack_public_path__ + "img/zone200350.d34f10f2.png";